"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TIERS_PER_FAMILY = exports.DEFAULT_TIER_LABELS = void 0;
exports.siblingTierIds = siblingTierIds;
exports.withTierSwap = withTierSwap;
exports.holdsPackageOrTier = holdsPackageOrTier;
exports.mergeOneTierPerFamily = mergeOneTierPerFamily;
exports.tierLabelOf = tierLabelOf;
/**
 * Package tiers (spec 2026-10-11). A tier is an ordinary package id grouped by
 * a PackageFamilyRecord. These helpers are the ONLY place that knows "two ids
 * are tiers of one package". Every reader degrades to today's exact-id
 * behaviour when it has no families.
 */
exports.DEFAULT_TIER_LABELS = ['Basic', 'Pro', 'Advanced'];
exports.MAX_TIERS_PER_FAMILY = 3;
function familyOf(id, families) {
    return families.find((f) => Array.isArray(f?.tierIds) && f.tierIds.includes(id));
}
function siblingTierIds(packageId, families) {
    const f = familyOf(packageId, families);
    return f ? f.tierIds.filter((t) => t !== packageId) : [];
}
function withTierSwap(current, granted, families) {
    // A family holds ONE tier: when the grant itself carries 2+ tiers of one
    // family, keep only the highest (latest in family.tierIds, lowest first).
    const grantedOnePerFamily = granted.filter((g) => {
        const f = familyOf(g, families);
        if (!f)
            return true;
        const rank = f.tierIds.indexOf(g);
        return !granted.some((o) => o !== g && f.tierIds.indexOf(o) > rank);
    });
    const drop = new Set(grantedOnePerFamily.flatMap((g) => siblingTierIds(g, families)));
    const kept = current.filter((id) => !drop.has(id));
    return [...new Set([...kept, ...grantedOnePerFamily])].filter(Boolean);
}
function holdsPackageOrTier(enabled, packageId, families) {
    if (enabled.includes(packageId))
        return true;
    return siblingTierIds(packageId, families).some((s) => enabled.includes(s));
}
function mergeOneTierPerFamily(productDefaults, stored, families) {
    const adopted = productDefaults.filter((d) => !stored.includes(d) && !siblingTierIds(d, families).some((s) => stored.includes(s)));
    // Product order first (as before), then whatever the deal stored.
    const ordered = productDefaults.filter((d) => stored.includes(d) || adopted.includes(d));
    return [...new Set([...ordered, ...stored])];
}
function tierLabelOf(pkg, _family) {
    if (pkg.tierLabel && pkg.tierLabel.trim())
        return pkg.tierLabel.trim();
    if (typeof pkg.tierRank === 'number' && pkg.tierRank >= 1)
        return exports.DEFAULT_TIER_LABELS[pkg.tierRank - 1];
    return undefined;
}
//# sourceMappingURL=packageTiers.js.map